export default __webpack_public_path__ + "img/weeklyNews1.68905cac.jpg";